const UIHelper = {
  isDomain(domain) {
    if (typeof window === 'undefined' || !window.location) return false;
    return window.location.origin.includes(domain);
  },

  isErogination() {
    return this.isDomain('erogination.com');
  },

  isDreamRoleAiDomain() {
    return this.isDomain('dreamrole-ai.com');
  },

  isDreamRoleOrErogination() {
    return this.isDreamRoleAiDomain() || this.isErogination();
  }
};

export default UIHelper;
